<template>
  <DialogTemplate
    :desktopFullscreen="true"
    :dark="true"
  >
    <SaveCurrentSpot
      :namespace
      class="mb-12 w-100"
    />
    <SavedSpotsTableV1
      class="w-100"
      :namespace
      @close="close"
    />

    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        @click.stop="$store.dispatch('router_reset_dialogs')"
      >
        {{ $t('btn.close') }}
      </v-btn>
    </template>
  </DialogTemplate>
</template>

<script>
import SavedSpotsTableV1 from '@/components/DataTables/v2/tables/SavedSpotsTableV1/SavedSpotsTableV1'
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import SaveCurrentSpot from '@/components/SaveCurrentSpot/SaveCurrentSpot'
import { SNK } from '@/helpers/helpers'

export default {
  name: 'RoadmapDialog',
  components: {
    SaveCurrentSpot,
    SavedSpotsTableV1,
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$store.dispatch(SNK('router_rm_dialog', this.dialog), 'saved-spots-dialog')
    },
  },
  computed: {
    namespace() {
      return this.dialog.namespace || ''
    },
  },
}
</script>
